document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".page-header--with-background").forEach(header => {
    const img = header.querySelector(".image-overlay__image img");
    if (!img) return;

    function setBgColor() {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });

        const w = img.naturalWidth || 1;
        const h = img.naturalHeight || 1;
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, w, h);

        // --- 1) Tjek yderste pixel til højre (øverste højre hjørne) ---
        const pixel = ctx.getImageData(w - 1, 0, 1, 1).data;
        const [pr, pg, pb] = pixel;

        // Hvis pixel er "næsten hvid"
        const isWhite = pr > 245 && pg > 245 && pb > 245;

        if (isWhite) {
          header.style.backgroundColor = `rgb(255,255,255)`; // ren hvid
          return;
        }

        // --- 2) Ellers brug gennemsnitsfarven (lysnet lidt) ---
        const sampleW = 20;
        const sampleH = Math.max(1, Math.round(sampleW * (h / w)));
        const c2 = document.createElement("canvas");
        const ctx2 = c2.getContext("2d", { willReadFrequently: true });
        c2.width = sampleW;
        c2.height = sampleH;
        ctx2.drawImage(img, 0, 0, sampleW, sampleH);

        const data = ctx2.getImageData(0, 0, sampleW, sampleH).data;
        let r = 0, g = 0, b = 0, count = 0;
        for (let i = 0; i < data.length; i += 4) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
          count++;
        }
        r = Math.round(r / count);
        g = Math.round(g / count);
        b = Math.round(b / count);

        // lys baggrunden lidt op
        const lighten = 0.3;
        r = Math.round(r + (255 - r) * lighten);
        g = Math.round(g + (255 - g) * lighten);
        b = Math.round(b + (255 - b) * lighten);

        header.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
      } catch (e) {
        console.warn("Could not compute bg color", e);
      }
    }

    if (img.complete) setBgColor();
    else img.addEventListener("load", setBgColor, { once: true });
  });
});